module.exports = __webpack_public_path__ + "img/10.df52db03.png";